import { useLocation } from 'react-router-dom';

const getBannerContent = (pathname) => {
  switch (pathname.split('/')[1]) {
    case 'contacts':
    case 'employees':
      return {
        title: 'Співробітники',
        description: 'Керуйте списком співробітників та їх картками СКД',
      };
    case 'accounts':
      return {
        title: 'Ваші платежі під контролем!',
        description: 'Вся інформація про оплати — під рукою',
      };
    case 'commodity-circulation':
      return {
        title: 'Звітувати — легко!',
        description: 'Передавайте дані про товарообіг без зайвого клопоту',
      };
    case 'requests':
      return {
        title: 'Комфортна комунікація без зайвих дзвінків!',
        description: 'Найшвидший спосіб узгодити ваші плани',
      };
    case 'create-request':
      return {
        title: 'Комфортна комунікація без зайвих дзвінків!',
        description: 'Найшвидший спосіб узгодити ваші плани',
      };
    default:
      return {
        title: 'Вітаємо!',
        description: 'Раді допомогти у вирішенні щоденних задач в ТРЦ Respublika Park',
      };
  }
};

const Banner = () => {
  const { pathname } = useLocation();
  const content = getBannerContent(pathname);

  return (
    <div className="banner">
      <div className="banner__inner">
        <div className="text-white-bold-f40-l48">{content.title}</div>
        <div className="text-white-medium-f22-l30">{content.description}</div>
      </div>
    </div>
  );
};

export default Banner;
